import React, { useState, useEffect } from "react";
import { auth, provider, signInWithPopup, signOut, db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import "./App.css";

function App() {
  const [user, setUser] = useState(null);
  const [grades, setGrades] = useState([]);

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      setUser(result.user);
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
    setGrades([]);
  };

  const loadGrades = async (email) => {
    try {
      const q = query(collection(db, "grades"), where("parentEmail", "==", email));
      const querySnapshot = await getDocs(q);

      let results = [];
      querySnapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });

      setGrades(results);
    } catch (err) {
      console.error("Error loading grades:", err);
    }
  };

  useEffect(() => {
    if (user) {
      loadGrades(user.email);
    }
  }, [user]);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <img
        src="/CCA-Logo.png"
        alt="CCA"
        style={{
          width: "200px",
          height: "auto",
          display: "block",
          margin: "0 auto",
        }}
      />
      <h1 style={{ textAlign: "center" }}>CCA Grade Portal</h1>

      {!user ? (
        <div className="center">
          <button onClick={handleLogin}>Login with Google</button>
        </div>
      ) : (
        <div className="centered">
          <p>
            <strong>Logged in:</strong> {user.email}
          </p>
          <button onClick={handleLogout}>Logout</button>

          <h2>Student Grades</h2>

          {grades.length === 0 ? (
            <p>No grades found for this account.</p>
          ) : (
            grades.map((g) => (
              <div
                key={g.id}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "16px",
                  margin: "12px",
                  width: "80%",
                  maxWidth: "600px",
                  backgroundColor: "#fafafa",
                }}
              >
                <h3>{g.studentName}</h3>
                <p>
                  <strong>Final Grade:</strong> {g.finalGrade}
                </p>
                <p>
                  <strong>Teacher:</strong> {g.teacherNames}
                </p>
                <p>
                  <strong>Last Updated:</strong>{" "}
                  {new Date(g.lastUpdated).toLocaleString()}
                </p>

                {g.breakdown && g.breakdown.length > 0 && (
                  <>
                    <h4>Grade Breakdown</h4>
                    <table border="1" cellPadding="6">
                      <tbody>
                        {g.breakdown.map((row, i) => {
                          const parts = row.split("|").map((x) => x.trim());
                          return (
                            <tr key={i}>
                              {parts.map((cell, j) => (
                                <td key={j}>{cell}</td>
                              ))}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default App;
